import * as React from "react";
import Link from "next/link";

import { BlogPostMetaData } from "@/types";
import { cn } from "@/lib/cn";

type BlogPostListItemProps = React.HTMLAttributes<HTMLLIElement> & {
  blog: BlogPostMetaData | null;
};

/**
 * Component for displaying a blog post list item.
 *
 * @param blog - The metadata of the blog post.
 */
const BlogPostListItem = React.forwardRef<HTMLLIElement, BlogPostListItemProps>(
  ({ blog, ...props }, ref) => {
    if (!blog) return null;

    const containerStyles = `
    active:!cursor-active md:bg-primary-950/70 bg-primary-950/50 ring-primary-500/50 md:hover:bg-primary-950/45 mx-auto w-full xl:max-w-screen-lg 2xl:max-w-screen-xl lg:max-w-screen-md xs:max-w-[90%] !cursor-pointer xs:rounded-2xl ring-1
  `;

    return (
      <li ref={ref} {...props} className={cn(containerStyles, props.className)}>
        <Link
          href={`/blogs/${blog.slug}`}
          className="active:cursor-active cursor-pointer"
        >
          <div className="xs:p-10 flex items-start justify-between gap-x-5 px-5 py-10">
            <div className="flex flex-1 flex-col gap-y-2">
              <h2 className="text-primary-300 max-w-md text-base font-medium leading-[1.6] md:text-xl xl:max-w-xl">
                {blog.title}
              </h2>
              <div className="flex items-center gap-x-2">
                {blog.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-primary-300/90 text-xs md:text-sm"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
            <span className="text-primary-300/90 text-xs md:text-sm">
              {blog.publishedAt}
            </span>
          </div>
        </Link>
      </li>
    );
  }
);

BlogPostListItem.displayName = "BlogPostListItem";

export default BlogPostListItem;
